import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { getIcon } from '../Button';
import { ButtonContain } from '../styles';

export const ComponentButtonIcon = ({
  icon,
  clickAction,
  buttonType,
  disabled = false,
  outline,
  tooltipMessage,
  iconDirection = 'left',
  color = 'blue',
  type = 'primary',
  ...rest
}) => {
  const renderButtonIcon = () => {
    return (
      <Button
        id="ComponenteButtonIcon"
        type={type}
        size={'large'}
        icon={getIcon(icon)}
        onClick={clickAction}
        disabled={disabled}
        {...rest}
      />
    );
  };

  return (
    <ButtonContain
      color={color}
      outline={outline}
      iconDirection={iconDirection}
      buttonType={buttonType}
      id="ComponenteButtonContain"
    >
      {tooltipMessage && !disabled ? (
        <Tooltip title={tooltipMessage} color={'#108ee9'} key={tooltipMessage}>
          {renderButtonIcon()}
        </Tooltip>
      ) : (
        renderButtonIcon()
      )}
    </ButtonContain>
  );
};

ComponentButtonIcon.propTypes = {
  icon: PropTypes.string,
  clickAction: PropTypes.func,
  buttonType: PropTypes.string,
  disabled: PropTypes.bool,
  outline: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  iconDirection: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.string,
};

ComponentButtonIcon.defaultProps = {
  // icon: null,
  // clickAction: () => {},
  // buttonType: null,
  // disabled: false,
  // outline: null,
  // tooltipMessage: null,
  // iconDirection: 'left',
  // color: 'blue',
  // type: 'primary',
};

export default ComponentButtonIcon;
